import Chip from '@shared/components/chips';
import { html } from '@shared/utils/rendering/html';
import { FilterTypes } from '@shared/components/advanced-filters/filter-types';

export const SarbSearchOptions = [
    { value: 0, text: 'All' },
    { value: 1, text: 'Question Text' },
    { value: 2, text: 'Principle' },
    { value: 3, text: 'Paragraph' },
];

export const SarbFilterGroups = {
    principle: 'principle',
    rating: 'rating',
};

export const SarbFilterDefaults = {
    selectedFilters: {},
    defaultSearchOption: { value: 0, text: 'All' },
    filters: [
        {
            label: 'Principle',
            identifier: SarbFilterGroups.principle,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            options: [
                { value: '1', text: 'Governance' },
                { value: '2', text: 'Data architecture and IT infrastructure' },
                { value: '3', text: 'Accuracy and integrity' },
                { value: '4', text: 'Completeness' },
                { value: '5', text: 'Timeliness' },
                { value: '6', text: 'Adaptability' },
                { value: '7', text: 'Accuracy' },
                { value: '8', text: 'Comprehensiveness' },
                { value: '9', text: 'Clarity and usefulness' },
                { value: '10', text: 'Frequency' },
                { value: '11', text: 'Distribution' },
            ],
        },
        {
            label: 'Rating',
            identifier: SarbFilterGroups.rating,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            // Chip embedded directly in each option's `text` (matching ERM-Portal's pattern in
            // users-table.filters.js) rather than relying on `transformer` — see the equivalent
            // comment in evidence-approaches-filters.config.js for why a `transformer`-only chip
            // disappears once selected.
            options: [
                {
                    value: '4',
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${{ text: '4 - Green' }}
                        css="bg-green"
                    />`,
                    css: 'bg-green',
                },
                {
                    value: '3',
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${{ text: '3 - Yellow' }}
                        css="bg-yellow"
                    />`,
                    css: 'bg-yellow',
                },
                {
                    value: '2',
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${{ text: '2 - Amber' }}
                        css="bg-amber"
                    />`,
                    css: 'bg-amber',
                },
                {
                    value: '1',
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${{ text: '1 - Red' }}
                        css="bg-red"
                    />`,
                    css: 'bg-red',
                },
                {
                    value: '0',
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${{ text: 'Not Assessed' }}
                        css="bg-requires-action"
                    />`,
                    css: 'bg-requires-action',
                },
            ],
        },
    ],
};
